import React from 'react';
import { fromPairs, map, get } from 'lodash';
import classnames from 'classnames';

// local Dependencies
import { getLabel } from 'utils/getLabel';
import { Icon } from 'modules/icon-bank';
import { Form } from 'modules/form';
import { button as Button } from 'modules/button';

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { serviceNow as ServiceNow } from 'ui/views/widgets/serviceNow';
 *
 * // render
 * <ServiceNow propName='propValue'/>
 */
export const serviceNow = ( props ) => {
    return (
        <div className='ui-service-now'>
			<div className='ui-service-now__header'>

				{ /* title for the modal */ }
				<div className='ui-service-now__header__title'>
					{ getLabel( props.title ) }
				</div>

				{ /* close button */ }
				<div
					className='ui-error-overlay__head__close'
					onClick={ () => props.closeOverlay() }
				>
					<Icon name='close' width='14' height='14' fill='#ffffff' />
				</div>
			</div>

			<div className='ui-service-now__body' onScroll={ props.onScroll }>
				<Form
                    fields={ fromPairs( map( props.fields, ( field ) => [ field.name, field ] ) ) } // convert to object as specified by `Form` prop
                    values={ get( props, 'values' ) } // default values
                    mode='form'
                    onChangeCallBack={ props.onChangeCallBack }
                    updatFieldsOnChange={ true }
                    onSubmit={ ( { values, isValid } ) => {
                        if( isValid ) {
                            props.onFormSubmit( values );
                        }
                    } }
                >
                    { ( { fields, values, /* isValid, */ errors, onChange, onSumbit } = {} ) => {

                        return (
                            <form
                                onSubmit={ onSumbit }
                                className='ui-service-now__body__form'
                            >
                                { /* fields */ }
                                { map( fields, field => {

                                    if( get( field, 'config.hide' ) ) {
                                        return null;
                                    }

                                    const fieldClassName = classnames( 'ui-service-now__body__form__field', `ui-service-now__body__form__${ field.name }` );
   
                                    return (
                                        <field.view
                                            className={ fieldClassName }
                                            key={ field.name }
                                            name={ field.name }
                                            required={ field.required }
                                            placeholder={ field.placeholder }
                                            label={ field.title }
                                            onChange={ onChange }
                                            value={ values[ field.name ] }
                                            error={ errors[ field.name ] }
                                            options={ 'formSection'  === field.type ? props.options : get( props.options, field.options ) }
                                            config={ field.config }
                                            mask={ field.mask }
                                            maxLength={ field.maxLength }
                                            closePopoverOnScrollTrigger={ props.closePopoverOnScrollTrigger }
                                        />
                                    );
                                } ) }

                                {/* actions */}
                                <div className='ui-service-now__body__form__actions'>
                                    { map( props.actions, action => {
                                        const actionName = action.name;

                                        return (
                                            <Button
                                                key={ actionName }
                                                id= { actionName }
                                                type= { 'submit' !== actionName ? 'button' : 'submit' }
                                                disabled={ 'cancel' !== actionName ? props.disableSubmit : false }
                                                outline={ 'cancel' === actionName ? true : false }
                                                size='large'
                                                className='ui-service-now__body__form__actions__action'
                                                onClick = {
                                                    'cancel' === actionName ?
                                                    () => props.closeOverlay() :
                                                    () => props.onActionClick( { name: actionName, values } )
                                                }
                                                { ...action }
                                            />
                                        );
                                    } ) }
                                </div>
                            </form>
                        );
                    } }
                </Form>
            </div>
		</div>
    );
};

// set display name
serviceNow.displayName = 'serviceNow';

// set default props
serviceNow.defaultProps = {};

// prop types
serviceNow.propTypes = {};
